import { render, staticRenderFns } from "./index-real-estate.vue?vue&type=template&id=c8679056&"
import script from "./index-real-estate.vue?vue&type=script&lang=js&"
export * from "./index-real-estate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports